/* RESPONSIBLE TEAM: team-inbox */
import ApplicationAdapter from '../application';

export default class DomainObjectInstanceAdapter extends ApplicationAdapter {
  pathForType() {
    return 'domain_objects';
  }
}
